export default {
      id: "mail-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#mail",
      toString: function () {
        return this.url;
      }
    }